<template>
  <Modal :is-open="isOpen" container-class="rounded-lg" ref="modal" :showCloseButton="false">
    <div class="px-4 py-2">
      <h2 class="text-center text-lg font-bold">Reenviar notificación</h2>
      <VistaGmail :notificacion="notificacion" />
    </div>
    <template #footer>
      <div class="m-2 flex flex-row justify-center space-x-4">
        <button
          class="btn btn-primary inline-flex items-center rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus:ring focus:ring-gray-300 focus:ring-opacity-50"
          @click="$emit('modal:close')"
        >
          Cancelar
        </button>

        <button
          class="btn btn-primary hover:bg-colescba-blue-50 inline-flex items-center rounded-md border border-colescba-blue-300 bg-colescba-blue-600 px-4 py-2 text-sm font-medium text-white transition duration-150 ease-in-out focus:outline-none focus:ring focus:ring-colescba-blue-300 focus:ring-opacity-50"
          @click="confirm"
        >
          <span v-if="!isSendingNotificacion">
            <p>Reenviar</p>
          </span>
          <span v-else class="flex flex-row space-x-2">
            <LoadingCircle class="h-7 w-7" />
            <p>Reenviando notificación...</p>
          </span>
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { useComposeModal } from '@colescba/ui'
import { useService } from '@colescba/app-vue'
import VistaGmail from './VistaGmail.vue'

export default {
  name: 'ReenviarNotificacion',
  components: { VistaGmail },
  props: {
    notificacion: { type: Object, required: true, default: null },
    solicitudId: { type: Number, required: true },
  },
  mixins: [useComposeModal(), useService('api')],
  data() {
    return {
      isSendingNotificacion: false,
    }
  },
  methods: {
    async confirm() {
      this.isSendingNotificacion = true
      await this.api.solicitudes.notificacion(this.solicitudId)
      this.isSendingNotificacion = false
      this.$emit('modal:close')
    },
  },
}
</script>
